"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var style_1 = require("../../../../style");
var variables_1 = require("../../../../style/variables");
var styles = {
    default: react_1.css({
        display: 'inline-flex',
        alignItems: 'center',
        padding: '0 12px',
        outline: 'none',
        minHeight: "var(" + variables_1.ComponentLayout.INPUT_HEIGHT_MD + ")",
        gap: 8,
        borderRadius: "var(" + variables_1.BorderRadius.sm + ")",
        position: 'relative',
        overflow: 'hidden',
        background: "var(" + variables_1.ComponentColor.Form.Background.BASE + ")",
        fontSize: style_1.pxToRem(14, 16),
        border: "1px solid var(" + variables_1.ComponentColor.Form.Border.DEFAULT + ")",
        transition: 'box-shadow, border 0.2s ease',
        ':hover': {
            border: "1px solid var(" + variables_1.ComponentColor.Form.Border.HOVER + ")",
        },
        ':focus-within': {
            border: "1px solid var(" + variables_1.ComponentColor.Form.Border.FOCUS + ")",
            boxShadow: "var(" + variables_1.Focus.PRIMARY_LIGHT + ")",
        },
        '> svg': {
            width: "var(" + variables_1.ComponentLayout.INPUT_ICON_SIZE_MD + ")",
            minWidth: "var(" + variables_1.ComponentLayout.INPUT_ICON_SIZE_MD + ")",
            height: "var(" + variables_1.ComponentLayout.INPUT_ICON_SIZE_MD + ")",
            minHeight: "var(" + variables_1.ComponentLayout.INPUT_ICON_SIZE_MD + ")",
            color: "var(" + variables_1.ComponentColor.Form.Icon.BASE + ")",
        },
        'input': {
            background: 'transparent',
            border: 'none',
            outline: 'none',
            padding: 0,
            margin: 0,
            fontWeight: 400,
            fontSize: style_1.pxToRem(14, 16),
            minWidth: 0,
            flex: 1,
            color: "var(" + variables_1.ComponentColor.Form.Text.FILLED + ")",
            '::placeholder': {
                fontWeight: 400,
                color: "var(" + variables_1.ComponentColor.Form.Text.PLACEHOLDER + ")",
            },
        },
    }),
    disabled: react_1.css({
        pointerEvents: 'none',
        background: "var(" + variables_1.ComponentColor.Form.Background.DISABLED + ")",
        border: "1px solid var(" + variables_1.ComponentColor.Form.Border.DISABLED + ")",
        '> svg': {
            color: "var(" + variables_1.ComponentColor.Form.Icon.DISABLED + ")",
        },
        ':hover': {
            border: "1px solid var(" + variables_1.ComponentColor.Form.Border.DISABLED + ")",
        },
        color: "var(" + variables_1.ComponentColor.Form.Text.DISABLED + ")",
        '::placeholder': {
            color: "var(" + variables_1.ComponentColor.Form.Text.DISABLED + ")",
        },
        'input': {
            color: "var(" + variables_1.ComponentColor.Form.Text.DISABLED + ")",
            '::placeholder': {
                color: "var(" + variables_1.ComponentColor.Form.Text.DISABLED + ")",
            },
        },
    }),
    readOnly: react_1.css({
        pointerEvents: 'none',
        background: "var(" + variables_1.ComponentColor.Form.Background.READONLY + ")",
        border: "1px solid var(" + variables_1.ComponentColor.Form.Border.READONLY + ")",
    }),
    error: react_1.css({
        border: "1px solid var(" + variables_1.ComponentColor.Form.Border.ERROR_DEFAULT + ")",
        ':hover': {
            border: "1px solid var(" + variables_1.ComponentColor.Form.Border.ERROR_HOVER + ")",
        },
        ':focus-within': {
            border: "1px solid var(" + variables_1.ComponentColor.Form.Border.ERROR_FOCUS + ")",
            boxShadow: "var(" + variables_1.Focus.ERROR_LIGHT + ")",
        },
    }),
    sm: react_1.css({
        minHeight: "var(" + variables_1.ComponentLayout.INPUT_HEIGHT_SM + ")",
        fontSize: style_1.pxToRem(12, 16),
        padding: '0 10px',
        '> svg': {
            width: "var(" + variables_1.ComponentLayout.INPUT_ICON_SIZE_SM + ")",
            minWidth: "var(" + variables_1.ComponentLayout.INPUT_ICON_SIZE_SM + ")",
            height: "var(" + variables_1.ComponentLayout.INPUT_ICON_SIZE_SM + ")",
            minHeight: "var(" + variables_1.ComponentLayout.INPUT_ICON_SIZE_SM + ")",
        },
        'input': {
            fontSize: style_1.pxToRem(12, 16),
        },
    }),
    block: react_1.css({
        display: 'flex',
    }),
    centered: react_1.css({
        'input': {
            textAlign: 'center',
        },
    }),
};
function InputContainer(_a) {
    var _b = _a.size, size = _b === void 0 ? 'md' : _b, readOnly = _a.readOnly, error = _a.error, block = _a.block, centered = _a.centered, element = _a.element, children = _a.children, props = __rest(_a, ["size", "readOnly", "error", "block", "centered", "element", "children"]);
    return react_1.jsx(element || 'label', __assign({ css: [
            styles.default,
            size === 'sm' ? styles.sm : undefined,
            block ? styles.block : undefined,
            centered ? styles.centered : undefined,
            error ? styles.error : undefined,
            readOnly ? styles.readOnly : undefined,
            props.disabled ? styles.disabled : undefined,
        ] }, props), children);
}
exports.default = InputContainer;
